module.exports = __webpack_public_path__ + "img/car_middle_white.7a9bf2ec.png";